import React from "react";
import pic1 from "../images/portfolio.png";
import pic2 from "../images/bitEditNotes.png";
import pic3 from "../images/railway.png";
import pic4 from "../images/birthday-wishing.png";

const Project = () => {
  return (
    <>
     <div id='project' className='section-padding'>
      <div>
        <h1 className="text-black text-4xl font-bold text-center mt-5 ">
          Projects
        </h1>
        <div className="grid sm:grid-cols-1 shadow-lg md-grid-cols-2 lg:grid-cols-2 m-8">
          <div className=" border border-solid rounded-xl shadow-lg	border-violet-100 ml-2 lg:ml-16 mb-4 p-2 hover:bg-slate-300">
            <img className="border border-solid border-violet-300 mx-auto mb-4" src={pic1}  alt="" width="500px" />
            <h2 className="text-center text-2xl underline font-mono font-extrabold">
              Portfolio website
            </h2>
            <h2 className="text-center text-lg font-mono">
              Tech stack: Tailwind CSS, React Js, Node Js, Mongo DB
            </h2>
            <div className="cols-2 m-2">
              <a href="https://64e0487e00639e1cd7a746fd--cerulean-mochi-104a94.netlify.app/" target="blank">
                <button class="m-2 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                  Website
                </button>
              </a>
              <a href="https://github.com/fatma-sia27/iamfatma" target="blank">
                <button class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                  Github
                </button>
              </a>
            </div>
          </div>

          <div className="border border-solid rounded-xl shadow-lg	border-violet-100 ml-2 lg:ml-16 mb-4  p-2 hover:bg-slate-300">
            <img src={pic3} className="mx-auto mb-4" alt="" width="700px" />
            <h2 className="text-center text-2xl underline font-mono font-extrabold">
              Railway project (did during my railway internship)
            </h2>
            <h2 className="text-center text-lg font-mono">
              Tech stack: Tailwind CSS, React Js, Node Js, Mongo DB
            </h2>
            {/* <div className="cols-2 m-2">
              
              <a href="https://drive.google.com/file/d/1JX4tgpkQpOyU57VZQxmKf0F5xMwCdv1R/view?usp=share_link">
                <button className="rounded-full bg-slate-300 border-zinc-600	m-2  border-2 border-solid p-3 hover:bg-zinc-500	 3xl mx-auto">
                  Github
                </button>
              </a>
            </div> */}
          </div>

          <div className="border border-solid rounded-xl shadow-lg	border-violet-100 ml-2 lg:ml-16 p-2 hover:bg-slate-300">
            <img src={pic2} className="mx-auto mb-4" alt="" width="700px" />
            <h2 className="text-center text-2xl underline font-mono font-extrabold">
              BitEditNotes
            </h2>
            <h2 className="text-center text-lg font-mono">
              Tech stack: React Js, Node Js, Mongo DB, Express js
            </h2>
            <div className="cols-2">
              <a href="https://github.com/fatma-sia27/bitP-editNotes" target="blank">
                <button class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                  Github
                </button>
              </a>
            </div>
          </div>

          <div className="border border-solid rounded-xl shadow-lg	border-violet-100 ml-2 mr-2 lg:ml-16 p-2 hover:bg-slate-300">
            <img src={pic4} className="mx-auto mb-4" alt="" width="700px" />
            <h2 className="text-center text-2xl underline font-mono font-extrabold">
              Birthday wishing app
            </h2>
            <h2 className="text-center text-lg font-mono">
              Tech stack: Kotlin , Java, Android
            </h2>
            <div className="cols-2">
              <a href="https://github.com/fatma-sia27/BirthdayGreetingsApp" target="blank">
                <button class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                  Github
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default Project;
